import { Helmet } from "react-helmet-async";

const SITE_URL = "https://jbarchitectseng.com";
const DEFAULT_IMAGE = `${SITE_URL}/jb_link_img.jpg`;

/**
 * Drop this at the top of any page component to control that page's
 * <title>, meta description, keywords, canonical URL and social preview
 * tags. Falls back to sensible site-wide defaults if a prop is omitted.
 *
 * Usage:
 *   <Seo
 *     title="Architects in Tirunelveli | JB Architects & Engineers"
 *     description="..."
 *     keywords={["architects in tirunelveli", "..."]}
 *     path="/about-us"
 *   />
 */
const Seo = ({
  title = "JB Architects & Engineers | Best Architects in Tirunelveli",
  description = "JB Architects and Engineers in Tirunelveli offer top architecture, engineering, interior and exterior design services for homes, offices, and commercial projects.",
  keywords = [],
  path = "/",
  image = DEFAULT_IMAGE,
  schema = null,
}) => {
  const canonical = `${SITE_URL}${path === "/" ? "/" : path.replace(/\/$/, "")}`;
  const keywordString = Array.isArray(keywords) ? keywords.join(", ") : keywords;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywordString && <meta name="keywords" content={keywordString} />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="JB Architects & Engineers" />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
